import { render } from "./tiptapEditor.vue?vue&type=template&id=eaa14b34&scoped=true"
import script from "./tiptapEditor.vue?vue&type=script&lang=js"
export * from "./tiptapEditor.vue?vue&type=script&lang=js"

import "./tiptapEditor.vue?vue&type=style&index=0&id=eaa14b34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaa14b34"]])

export default __exports__